

























import Vue from 'vue';

// Services
import AonContext from '~/services/AonContext';
import AnalyticService from '~/services/AnalyticService';

// Components
import Header from '~/components/layouts/Header.vue';
import AssessmentFooter from '~/shared/assessments/AssessmentFooter.vue';
import AssessmentCard from '~/shared/assessments/AssessmentCard.vue';
import Section2 from '~/views/assessmentscenter/components/AssessmentSection2.vue';
import Section4 from '~/views/assessmentscenter/components/AssessmentSection4.vue';
import Section5 from '~/views/assessmentscenter/components/AssessmentSection5.vue';
import NavLink from '~/components/navigation/NavLink.vue';

export default Vue.extend({
    name: 'AssessmentsCenter',
    components: {
        Header,
        AssessmentCard,
        AssessmentFooter,
        Section2,
        Section4,
        Section5,
        NavLink,
    },
    data() {
        return {
            context: null as AonContext | null,
        };
    },
    computed: {
        hasConsented(): boolean {
            return Boolean(this.context && this.context.hasConsented);
        },
    },
    methods: {
        refreshContext() {
            AonContext.new({
                include_instruments: true,
            }).then(context => {
                this.context = context;
                this.handleQueryParams(context);
            });
        },
        handleQueryParams(context: AonContext) {
            // Open freemium or premium based on query
            const urlParams = new URLSearchParams(window.location.search);
            const hasGoTo: boolean = urlParams.has('goTo');
            if (hasGoTo) {
                switch (urlParams.get('goTo')) {
                    case 'premium': {
                        context.openPremium();
                        break;
                    }
                    case 'freemium': {
                        context.openFreemium();
                        break;
                    }
                }
            }
        },
    },
    mounted() {
        AnalyticService.impressionEvent(
            AnalyticService.IMPRESSION_ACTIONS.MYASSESSMENTS_VIEW_ACTION
        );
        this.refreshContext();

        // We need to know the price of the premium product
        AonContext.fetchAonProductFromBilling();
    },
});
